import { useState } from "react";
import { RadioGroup, Switch, type RadioOption } from "@/components";
import { setSingleKeyShortcutsEnabled, singleKeyShortcutsEnabled } from "@/lib/hooks";
import { THEMES, type ThemeChoice } from "@/app/theme/themes";
import { useThemeSwitcher } from "@/app/theme/useThemeSwitcher";
import styles from "../settings.module.css";

const THEME_OPTIONS: RadioOption<ThemeChoice>[] = [
  ...THEMES.map((theme) => ({ value: theme.id, label: theme.label, description: theme.description })),
  { value: "system", label: "Match system", description: "Light or dark, following your device setting." },
];

/** Theme (this device and the workspace) and keyboard preferences (this device). */
export function AppearanceSection() {
  const { choice, choose } = useThemeSwitcher();
  const [singleKey, setSingleKey] = useState(singleKeyShortcutsEnabled);
  return (
    <div className={styles.panel}>
      <div className={styles.stack}>
        <RadioGroup<ThemeChoice>
          label="Theme"
          description="Applies at once. Saved on this device and in the workspace, so new devices start with it."
          options={THEME_OPTIONS}
          value={choice}
          onValueChange={choose}
        />
      </div>
      <div className={styles.stack}>
        <Switch
          label="Single-key shortcuts"
          description="Shortcuts without ⌘ or Ctrl. They never fire while you type in a field. Saved on this device."
          checked={singleKey}
          onCheckedChange={(checked) => {
            setSingleKeyShortcutsEnabled(checked);
            setSingleKey(checked);
          }}
        />
      </div>
    </div>
  );
}
